import { RootSchema } from "../../../redux/reducers";
import { AnalyticsEvent } from "../types";
import { mapStaticMutation } from "./helpers";

export const mapMfaAnalyticsEvents = (previousState: RootSchema, currentState: RootSchema): AnalyticsEvent[] => [
  ...mapStaticMutation(previousState.securityConfiguration?.secondFactorAuthentication, currentState.securityConfiguration?.secondFactorAuthentication, {
    trackedEventNames: ["mfa_enabled", "mfa_saved", "mfa_disabled", "mfa_factor_enabled", "mfa_factor_disabled", "mfa_factor_got_error"]
  }),
  ...mapStaticMutation(previousState.securityConfiguration?.googleAuthenticator, currentState.securityConfiguration?.googleAuthenticator, {
    errorEventName: "mfa_factor_got_error",
    trackedEventNames: ["mfa_factor_enabled", "mfa_factor_configured_successfully", "mfa_factor_disabled", "mfa_factor_got_error"]
  }),
  ...mapStaticMutation(previousState.securityConfiguration?.duoSecondFactorAuthentication, currentState.securityConfiguration?.duoSecondFactorAuthentication, {
    errorEventName: "mfa_factor_got_error",
    trackedEventNames: ["mfa_factor_enabled", "mfa_factor_configured_successfully", "mfa_factor_disabled", "mfa_factor_got_error"]
  }),
  ...mapStaticMutation(previousState.securityConfiguration?.pushNotify, currentState.securityConfiguration?.pushNotify, {
    errorEventName: "mfa_factor_got_error",
    trackedEventNames: ["mfa_factor_enabled", "mfa_factor_configured_successfully", "mfa_factor_disabled", "mfa_factor_got_error"]
  }),
  ...mapStaticMutation(previousState.securityConfiguration?.securityquestions, currentState.securityConfiguration?.securityquestions, {
    errorEventName: "mfa_factor_got_error",
    trackedEventNames: ["mfa_factor_enabled", "mfa_factor_configured_successfully", "mfa_factor_disabled", "mfa_factor_got_error"]
  }),
  ...mapStaticMutation(previousState.passkey, currentState.passkey, {
    errorEventName: "mfa_factor_got_error",
    trackedEventNames: ["mfa_factor_enabled", "mfa_factor_configured_successfully", "mfa_factor_disabled", "mfa_factor_got_error"]
  })
];
